import OrganizationService from "src/services/OrganizationService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name: "",
	style: "",
	domain: "",
	view: "",
	out_register: false,
	show_updates: true,
	games_for_all_organization: true,
	logo: ""
};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.organization,
@property  {array}  modules.organizations
**/

const modulez = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("organization", OrganizationService, modulez, types ,params);
